export default "__VITE_ASSET__CZkiXuT1__"